import React, { useState, useEffect } from 'react'

import { useDebounce } from 'usehooks-ts'
import Select from 'react-select'
import axios from 'axios'

export default function AddressAutocomplete({ field, error, placeholder }) {
  const [address, setAddress] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const debouncedAddress = useDebounce(address, 125)

  useEffect(() => {
    // Minimum length to make a request
    if (debouncedAddress.length > 2) {
      axios
        .post(
          'https://api.lob.com/v1/us_autocompletions',
          {
            address_prefix: debouncedAddress,
            state: 'KY',
          },
          {
            headers: {
              Authorization: `Basic ${process.env.NEXT_PUBLIC_LOB_API_KEY}:`, // ":" is to prevent the requirement of a password for API requests, as reccomended by Lob docs
              'Content-Type': 'application/json',
            },
          }
        )
        .then((res) => {
          setSuggestions(res.data.suggestions)
        })
    } else {
      setSuggestions([])
    }
  }, [debouncedAddress])

  const handleInputChange = async (event) => {
    setAddress(event)
  }

  return (
    <Select
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...field}
      className="address-select"
      classNamePrefix="address-select"
      onInputChange={(e) => {
        handleInputChange(e)
      }}
      options={suggestions}
      getOptionLabel={(option) =>
        `${option.primary_line} - ${option.city}, ${option.state} ${option.zip_code}`
      }
      getOptionValue={(option) => option.primary_line}
      placeholder={placeholder ? placeholder : ''}
      noOptionsMessage={() => 'Begin typing an address'}
      isClearable
      styles={{
        control: (baseStyles, state) => {
          const border = state.isFocused
            ? '2px solid #57b3e4'
            : error
            ? '2px solid #ff8a85'
            : '2px solid white'
          return {
            ...baseStyles,
            boxShadow: 'none',
            border,
            '&:hover': {
              border,
            },
          }
        },
      }}
    />
  )
}
